import _regeneratorRuntime from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import * as Sentry from '@sentry/vue';
import { Meteor } from 'meteor/meteor';
import { Tracker } from 'meteor/tracker';
import { appEnvironment, appRelease } from "../functions/environment";
export default
/*#__PURE__*/
(function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var Vue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Vue = _ref.Vue;

            // test and production builds only; dev sends nothing (#320)
            if (process.env.PROD) {
              Sentry.init({
                Vue: Vue,
                // the build's git commit and its target (#70), so an error says which deploy it came from
                release: appRelease(),
                environment: appEnvironment(),
                logErrors: true,
                dsn: 'https://e9afb7a7ec7f402cacc5d78f6b6edf59@o280731.ingest.sentry.io/5395582',
                // @sentry/vue 7 has tracing and the session recording (Replay) built in (#606); 7.x is the last line for
                // today's build: 8.x needs Node 14.18 to install and ships newer syntax that webpack 4 may not parse
                integrations: [Sentry.browserTracingIntegration(), // the recording stays on (#400): every error comes with a recording, of about the last minute before it
                // and the rest of that visit (Replay's on-error mode; @sentry/rrweb sent the whole visit); text and
                // images show as before, typed input stays masked
                Sentry.replayIntegration({
                  maskAllText: false,
                  blockAllMedia: false
                })],
                replaysSessionSampleRate: 0,
                replaysOnErrorSampleRate: 1.0,
                // We recommend adjusting this value in production, or using tracesSampler
                // for finer control
                tracesSampleRate: 1.0
              }); // an error names the logged-in user (the user, 20 Oct 2026): set at login and on a reload with a session,
              // cleared at logout; while a stored login is still loading the user stays as it was

              Tracker.autorun(function () {
                var user = Meteor.user();

                if (user) {
                  var email = user.emails && user.emails[0] && user.emails[0].address;
                  Sentry.setUser({
                    id: user._id,
                    email: email
                  });
                } else if (!Meteor.userId()) {
                  Sentry.setUser(null);
                }
              });
            }

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();